module.exports = __webpack_public_path__ + "static/media/food123.4ebf2c3d.jpg";